module.exports = __webpack_public_path__ + "img/1.e0ef81d7.jpg";